import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=3ef3e974&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=js"
export * from "./ActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=3ef3e974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3e974",
  null
  
)

export default component.exports